/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { ActivateTemplateDialog } from '../../-components/ActivateTemplateDialog';
import { CreateScoringTemplateDialog } from '../../-components/CreateScoringTemplateDialog';
import { DeleteScoringTemplatesDialog } from '../../-components/DeleteScoringTemplatesDialog';
import { ScoringTemplatesTable } from '../../-components/ScoringTemplatesTable';
import { useScoringTemplatesPage } from '../../-hooks/useScoringTemplatesPage';

export const Route = createFileRoute(
  '/management/scoring-templates/(pages)/(list)/',
)({
  component: ScoringTemplatesPage,
});

function ScoringTemplatesPage() {
  const page = useScoringTemplatesPage();

  return (
    <PageContainer>
      <ScoringTemplatesTable page={page} />
      <CreateScoringTemplateDialog
        open={page.isCreateOpen}
        isSubmitting={page.isCreating}
        onClose={page.closeCreate}
        onSubmit={page.submitCreate}
      />
      <DeleteScoringTemplatesDialog
        pending={page.pendingDelete}
        onCancel={page.cancelDelete}
        onConfirm={() => void page.confirmDelete()}
      />
      <ActivateTemplateDialog
        pending={page.pendingActivate}
        onCancel={page.cancelActivate}
        onConfirm={() => void page.confirmActivate()}
      />
    </PageContainer>
  );
}
